import { useCallback, useMemo, useState } from "react";

function usePagination(totalResults: number, itemsPerPage: number) {
  const [currentPage, setCurrentPage] = useState(1);
  const safeTotalResults = Number.isFinite(totalResults) ? Number(totalResults) : 0;
  const safeItemsPerPage = Number.isFinite(itemsPerPage) && itemsPerPage > 0 ? Number(itemsPerPage) : 1;
  const maxPage = Math.max(1, Math.ceil(safeTotalResults / safeItemsPerPage));
  const pageIndices = useMemo(() => {
    const indices = [];
    for (let i = 1; i <= maxPage; i++) {
      indices.push(i);
    }
    return indices;
  }, [maxPage]);

  const next = useCallback(() => {
    setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
  }, [maxPage]);

  const prev = useCallback(() => {
    setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
  }, []);

  const jump = useCallback((page: number) => {
    const pageNumber = Math.max(1, page);
    setCurrentPage((_currentPage) => Math.min(pageNumber, maxPage));
  }, [maxPage]);

  return { next, prev, jump, currentPage, maxPage, pageIndices };
}

export default usePagination;
